<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.transfer_detail') }}:
            span {{ $t('strings.description', {attribute: $t('strings.transfer_details')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="transferDetails")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('transfer_details.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'quantity_shipment' || column == 'quantity_transfer' || column == 'quantity_received' || column == 'quantity_difference'") {{ data[indextr][column] | currency('') }}
                  slot(v-if="column == 'product_code' || column == 'product_name'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status_reception_product_id'" :pulse="data[indextr][column] == '1'" :color="colorStatus(data[indextr][column])") {{ $t('transfer_details.'+ data[indextr]['status_reception_product_display']) }}
</template>

<script>
import ViewMixinMaster2 from '@/mixins/ViewMixinMaster2'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('TransferDetails')
export default {
  name: 'TransferDetails',
  components: {},
  mixins: [ViewMixinMaster2],
  data: () => ({
    columns: [
      'product_code',
      'product_name',
      'quantity_transfer',
      'quantity_shipment',
      'quantity_received',
      'quantity_difference',
      'status_reception_product_id'
    ],
    columnsOrderBy: [],
    attributeModal: '',
    status: [
      {
        value: 1,
        color: 'danger'
      },
      {
        value: 2,
        color: 'success'
      },
      {
        value: 3,
        color: 'warning'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['transferDetails'])
  },
  async created () {
    await this.loadData()
  },
  methods: {
    ...mapActions([
      'loadDetails'
    ]),
    async loadData () {
      await this.loadDetails({ id: this.$route.params.id })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-tablex.vm-table--content {
  overflow: visible !important;
}
thead.vm-table--thead-table {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: white;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
